'use es6';

import { getStaticColumns } from './constants';
import { renderCell } from '../lib/salesAnalytics/renderUtils';
import { callWidgetDrilldown } from '../lib/salesAnalytics/drilldowns';
import { getBucketField, getBreakdownField, getMetricField } from '../lib/salesAnalytics/helpers';
import { getBreakdownColumns } from '../lib/salesAnalytics/tableColumns';
export const getTableColumns = (report, data, onDrilldown) => {
  const bucketField = getBucketField(report);
  const breakdownField = getBreakdownField(report);
  const metricField = getMetricField(report);
  if (!breakdownField) {
    return {
      data,
      columns: getStaticColumns({
        report,
        onDrilldown,
        bucketField,
        metricField
      })
    };
  }
  const cleanData = data.updateIn(['primary', 'data', 'properties'], properties => properties.merge(data.getIn(['primary', 'data', 'properties', breakdownField, 'references'])));
  const breakdownColumns = getBreakdownColumns(breakdownField, data);
  const renderTableCell = args => renderCell(args, `SUM|${metricField}`);
  const columns = [{
    field: bucketField,
    dataset: 'primary'
  }, ...breakdownColumns.map(column => ({
    field: column,
    dataset: 'primary',
    renderCell: renderTableCell,
    onClick: callWidgetDrilldown(report, onDrilldown),
    align: 'right'
  })), {
    field: 'quotaAmount',
    dataset: 'primary'
  }];
  return {
    data: cleanData,
    columns
  };
};